var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"24px","height":"24px"},attrs:{"title":_vm.tooltipMessage},domProps:{"innerHTML":_vm._s(_vm.icon())}})}
var staticRenderFns = []

export { render, staticRenderFns }